import styled from 'styled-components';

export const Container = styled.div.attrs(() => ({
  className: 'ClassroomDetailsContainer',
}))`
  margin: 0 auto;
  box-shadow: 0 2px 4px 0 #00000015;
  width: 100%;


  .breadcrumbs-container {
    display: none;
  }

  .legoTabsWrapper {
    justify-content: flex-start;
    .legoTabsItem {
      font-size: 16px;
      max-width: 160px;
      font-weight: normal;
    }
  }

  ${({ theme }: any) => theme.breakPoints.tablet} {

    margin: 80px auto 100px auto;
    .breadcrumbs-container {
      margin: 0;
      display: flex;
      padding-bottom: 20px;
      background-color: #f8f8f8;
    }
  }
`;

Container.displayName = 'SettingsClassroomDetailsContainer';
